// import 'vite/dynamic-import-polyfill'
import { DEPLOY_ENV } from '@base/constants'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import './assets/styles/entry.css'
import './assets/styles/main.scss'
import { configureStore } from './easy-redux/index'
import { routeMapping } from './routes/index'
import { RouterMode } from './routes/renderMode'
import RenderRoutes from './routes/renderRoutes'
import sensors, { SensorsInit } from './utils/sensors'
import VConsole from 'vconsole'
import { getUrl } from '@fe/utils'

console.info('[BUILD_TIME]', process.env.BUILD_TIME)
console.info('[ENV]', DEPLOY_ENV)

const debug = getUrl(location.href, 'debug')
if (debug) {
  new VConsole()
}

SensorsInit()

sensors.use('PageLeave', {}) //用于采集 $PageLeave 事件。

ReactDOM.render(
  <Provider store={configureStore}>
    <RouterMode>
      <RenderRoutes routes={routeMapping} />
    </RouterMode>
  </Provider>,
  document.getElementById('root')
)
